import {
  messageSchema,
  MessageMarkdownTransformer,
} from '@chatwoot/prosemirror-schema';

const MARKDOWN_IMAGE_PATTERN = /!\[[^\]]*]\([^)]+\)/;
const HTML_IMAGE_PATTERN = /<img[\s\S]*?>/i;
const IMAGE_TOKEN_ERROR_KEYWORDS = [
  'Token type `image` not supported by Markdown parser',
  'Markdown parser',
  'Token type `image`',
];

export const containsMarkdownImage = content =>
  MARKDOWN_IMAGE_PATTERN.test(content || '');

export const containsHtmlImage = content =>
  HTML_IMAGE_PATTERN.test(content || '');

export const canRenderWithRichEditor = content => {
  if (!content) return true;

  try {
    new MessageMarkdownTransformer(messageSchema).parse(content);
    return true;
  } catch (error) {
    return false;
  }
};

export const shouldUsePlainTextMode = content => {
  if (!content) return false;

  return (
    containsMarkdownImage(content) ||
    containsHtmlImage(content) ||
    !canRenderWithRichEditor(content)
  );
};

export const isUnsupportedImageTokenError = error =>
  IMAGE_TOKEN_ERROR_KEYWORDS.some(keyword =>
    (error?.message || '').includes(keyword)
  );
